export default __webpack_public_path__ + "static/media/info-circle.7b84277c.svg";